export default __webpack_public_path__ + "static/media/favicon.47d7d9c7.ico";